import { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { ContentApi } from "../../../../shared/api/contentApi";
import { Form, Input, App } from "antd";
import { useContentContext } from "../../ContentContext";
import {
    UiDialogRoot,
    UiDialogContent,
    UiDialogTitle,
    UiDialogDescription,
    UiDialogClose,
    UiDialogHeader,
    UiDialogBody,
    UiDialogFooter,
} from "../../../../components/ui/ant/Dialog";
import AutoApplyEntitiesField from "./AutoApplyEntitiesField";
import SelectParentGroup from "./ParentGroupOrderParameter";


export default function GroupParameterCreateDialog({ open, onClose, onCreated }) {
    const { projectId, versionId } = useContentContext();
    const [systemName, setSystemName] = useState("");
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");

    const [applyItems, setApplyItems] = useState([]);

    const [parentGroupId, setParentGroupId] = useState(null);

    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        if (!open) return;
        setSystemName("");
        setName("");
        setDescription("");
        setApplyItems([]);
        setParentGroupId(null);
        setError("");
        setSaving(false);
    }, [open]);


    const canSubmit = useMemo(
        () => !!systemName.trim() && !!name.trim() && !saving,
        [systemName, name, saving],
    );

    const onSubmit = async (e) => {
        e?.preventDefault?.();
        if (!canSubmit) return;

        setSaving(true);
        setError("");

        try {
            const payload = {
                systemName: systemName.trim(),
                name: name.trim(),
                description: description.trim() || null,
                parentGroupParameterId: parentGroupId || null,
                autoApplyForEntityTypes: applyItems.length > 0 ? applyItems : [],
            }
            const created = await ContentApi.createParameterGroup(payload);
            onCreated?.(created);
            onClose?.();
        } catch (e) {
            setError(e?.message || "Не удалось создать параметр");
        } finally {
            setSaving(false);
        }
    };

    if (!open) return null;

    return (
        <App>
        <UiDialogRoot open={open} onOpenChange={(next) => !next && onClose?.()}>
            <UiDialogContent size="lg">
                <UiDialogHeader>
                    <div>
                        <UiDialogTitle>Создать группу для параметров</UiDialogTitle>
                        <UiDialogDescription>Группа параметров текущей версии</UiDialogDescription>
                    </div>
                    <UiDialogClose showIcon />
                </UiDialogHeader>

                <UiDialogBody>
                    {error && (
                        <div className="mb-4 rounded-xl border border-red-300 bg-red-50 text-red-700 p-3 text-sm">
                            {error}
                        </div>
                    )}

                    <Form layout='vertical' className="space-y-4" onSubmit={onSubmit}>
                        <Form.Item label="systemName" className="flex flex-col">
                            <Input
                                className="input w-full"
                                value={systemName}
                                onChange={(e) => setSystemName(e.target.value)}
                                placeholder="parameter_damage"
                                required
                            />                    
                        </Form.Item>

                        <Form.Item label="Название *" className="flex flex-col">
                            <Input
                                className="input w-full"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder="Название параметра, например Урон"
                                required
                            />
                        </Form.Item>

                        <Form.Item label="Описание" className="flex flex-col">
                            <Input.TextArea
                                className="input w-full"
                                rows={3}
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                placeholder="Описание параметра, например урон наносимый пользователю"
                            />
                        </Form.Item>

                        {/* Select ParentGroup */}

                        <SelectParentGroup
                            open={open}
                            projectId={projectId}
                            versionId={versionId}
                            value={parentGroupId}
                            onChange={setParentGroupId}
                        />

                        <AutoApplyEntitiesField
                            open={open}
                            projectId={projectId}
                            versionId={versionId}
                            selectedSystemNames={applyItems}
                            onChange={setApplyItems}
                        />
                    </Form>
                </UiDialogBody>

                <UiDialogFooter>
                    <button type="button" className="btn btn-soft-accent" onClick={onSubmit} disabled={!canSubmit}>
                        {saving ? "Создаем..." : "Создать"}
                    </button>
                    <button type="button" className="btn btn-outline" onClick={onClose}>
                        Отмена
                    </button>
                </UiDialogFooter>
            </UiDialogContent>
        </UiDialogRoot>
        </App>
    );
}

GroupParameterCreateDialog.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onCreated: PropTypes.func,
};
